import React, { useContext, useEffect } from "react";
import "./TopBar.scss";

import { Button, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { PersonCircle } from "react-bootstrap-icons";
import { UserContext } from "../../api/user/userContext";
import opencardsLogo from "../../assets/opencards-logo.png";
import opencardsIcon from "../../assets/opencards-icon.png";
import { Link } from "react-router-dom";
import XeesterUser from "../../api/user/User";
import { SidebarContext } from "../../api/sidebar/SidebarContext";
import { Avatars } from "../../api/ReplayVariables";
import LanguageSelector from "./LanguageSelector";

function TopBar({ location, onShowLogin }) {
  const { user, dispatchUser } = useContext(UserContext);
  const { open, dispatchSidebar } = useContext(SidebarContext);

  const { t } = useTranslation();

  const toggleOpen = () => {
    console.log("toggle", !open);
    dispatchSidebar({ type: "toggle", payload: false });
  };

  let profileUrl = window.serverUrl+"";
  switch (i18n.language) {
    case "fr": {
      profileUrl += "/fr/mon-espace/mon-profil";
      break;
    }
    case "en": {
      profileUrl += "/en/my-space/my-profile";
      break;
    }
    case "it": {
      profileUrl += "/it/il-mio-spazio/il-mio-account";
      break;
    }
    case "pt": {
      profileUrl += "/pt/meu-espaco/meu-perfil";
      break;
    }
    default: {
      break;
    }
  }

  const logout = () => {
    const disconnectUrl =
      window.serverUrl+"/index.php?option=com_users&task=user.logout";
    fetch(disconnectUrl)
      .then((_data) => {
        dispatchUser({ type: "disconnect" });
      })
      .catch((err) => {
        console.error("fetch problem", err);
        dispatchUser({ type: "disconnect" });
      });
  };

  const letters = [
    "a",
    "z",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "q",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "w",
    "x",
    "c",
    "v",
    "b",
    "n"
  ];

  const getAvatar = (pseudo) => {
    let letter = pseudo.substring(0, 1).toLowerCase();
    if (letters.indexOf(letter) !== -1) {
      return Avatars["avatar" + letter.toUpperCase()];
    } else {
      return Avatars.avatarA;
    }
  };

  useEffect(() => {
    //FETCH HAND DETAILS
    //console.log("topbar effect", location);

    //FETCH USER
    //console.log("location", document.location.href);
    let local = document.location.href.indexOf(":7743") != -1;
    if (!local) {
      console.log("user from topbar");
      fetch(window.serverUrl+`/social/user.php`)
        .then((r) => r.json())
        .then((_user) => {
          dispatchUser({ type: "update", payload: XeesterUser.from(_user) });
        })
        .catch((err) => {
          console.error("fetch problem", err);
        });
      return () => {
        //console.log("topbar done");
      };
    } else {
      const timer = setTimeout(() => {
        dispatchUser({
          type: "update",
          payload: XeesterUser.from({
            id: 22253,
            name: "",
            username: "",
            email: "",
            registerDate: "2012-04-17 16:30:42",
            avatar: "users/avatar192.png",
            cb_description: "test\n\test\ntest",
            cb_notifications: "subscriptions|*|comments|*|replays",
            canvas: "canvas_22253.png",
            subscriptions: [],
            subscribers: 0,
            replays: 2
          })
        });
      }, 0);
      return () => {
        //console.log("topbar done");
        clearTimeout(timer);
      };
    }
  }, [location, open, dispatchUser]);

  return (
    <div className="topbar d-flex align-items-center">
      <div className="topbar-inner d-flex align-items-center">
        <Button className="custom-toggler" type="button" onClick={toggleOpen}>
          <span className="navbar-toggler-icon"> </span>{" "}
        </Button>
        <Link data-tio={t("home")} data-for="app-tooltip" to="/">
          <img
            className="opencards-logo"
            src={opencardsLogo}
            alt="Opencards logo"
          />
          <img
            className="opencards-icon"
            src={opencardsIcon}
            alt="Opencards icon"
          />
        </Link>{" "}
        {user === null || user.error === 401 ? (
          <Button className="login" onClick={onShowLogin}>
            <PersonCircle className="avatar"> </PersonCircle>&nbsp;{" "}
            <div className="username"> {t("replayApp.user.login")} </div>{" "}
          </Button>
        ) : (
          <Dropdown className="pseudo">
            <Dropdown.Toggle className="d-flex">
              {" "}
              {user.avatar ? (
                <img
                  className="avatar-image"
                  src={
                    window.serverUrl+"/media/kunena/avatars/" +
                    user.avatar
                  }
                  alt="avatar"
                />
              ) : (
                <img className="avatar" src={getAvatar(user.username)} alt="" />
              )}{" "}
              <div className="username">&nbsp;{user.username}&nbsp;</div>{" "}
            </Dropdown.Toggle>{" "}
            <Dropdown.Menu className="pseudo-menu">
              <Dropdown.Item
                eventKey="1"
                href={profileUrl}
                className="d-flex align-items-center"
              >
                {user.avatar ? (
                  <img
                    className="avatar-image"
                    src={
                      window.serverUrl+"/media/kunena/avatars/" +
                      user.avatar
                    }
                    alt="avatar"
                  />
                ) : (
                  <img
                    className="avatar"
                    src={getAvatar(user.username)}
                    alt=""
                  />
                )}{" "}
                <div>
                  &nbsp; &nbsp; {user.name} <br />
                  &nbsp; &nbsp; {user.email}{" "}
                </div>{" "}
              </Dropdown.Item>{" "}
              <Dropdown.Divider />
              <Dropdown.Item eventKey="4" onClick={logout}>
                {" "}
                {t("replayApp.user.disconnect")}{" "}
              </Dropdown.Item>{" "}
            </Dropdown.Menu>{" "}
          </Dropdown>
        )}{" "}
        <LanguageSelector> </LanguageSelector>{" "}
      </div>{" "}
    </div>
  );
}

export default TopBar;
